import { render, staticRenderFns } from "./M24.vue?vue&type=template&id=2be9bd08&scoped=true"
import script from "./M24.vue?vue&type=script&lang=js"
export * from "./M24.vue?vue&type=script&lang=js"
import style0 from "./M24.vue?vue&type=style&index=0&id=2be9bd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9bd08",
  null
  
)

export default component.exports